import React from 'react';
import './App.css';
import { ExampleA } from './components/examples/example-A/example-A';
import { ExampleB } from './components/examples/example-B/example-B';
import { ExampleC } from './components/examples/example-C/example-C';

function App() {
  return (
    <div className="App">
      <ExampleA/>
      <ExampleB/>
      <ExampleC/>
    </div>
  );
}

export default App;
